import validate from "/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import browser_45global from "/src/app/middleware/browser.global.ts";
import location_45global from "/src/app/middleware/location.global.ts";
import manifest_45route_45rule from "/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  browser_45global,
  location_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/src/app/middleware/auth.ts"),
  category: () => import("/src/app/middleware/category.ts"),
  redirects: () => import("/src/app/middleware/redirects.ts"),
  register: () => import("/src/app/middleware/register.ts"),
  service: () => import("/src/app/middleware/service.ts"),
  widget: () => import("/src/app/middleware/widget.ts")
}